import {
  CoinbaseProfileMenuLabelKey,
  CoinbaseProfileMenuResource,
} from '@cbhq/identity-api-hooks/profile-menu/types';

import { HelpMenu, MenuActionItem, ProfileMenuContextType, ProfilesType } from '../types';

export const MOCK_RESOURCES: CoinbaseProfileMenuResource[] = [
  {
    name: 'Ahmed Elhassan',
    logoUrl:
      'https://res.cloudinary.com/coinbase-dev/image/upload/f_png,c_fill,h_128,w_128/y9n5ewgyhssrq4p35mka.png',
    identityAccountId: '3f8243de-3170-5a40-94ad-1640a41162ba',
    resourceType: 'user',
  },
  {
    name: 'Nexus 1',
    identityAccountId: '0ca6f028-69f7-4b4d-b128-be31925b7d0f',
    resourceType: 'legal_entity',
    parentId: 'C8D13E39-CEF0-4035-98E8-A59527650777',
  },
  {
    name: 'Nexus 2',
    identityAccountId: 'ACD051DC-98CF-4F08-B294-DDBDC2025499',
    resourceType: 'legal_entity',
    parentId: 'C8D13E39-CEF0-4035-98E8-A59527650777',
  },
  {
    name: 'Nexus 4',
    identityAccountId: 'D3703B1-9338-4CF2-AF32-AF0E3F30C1C9',
    resourceType: 'legal_entity',
    parentId: '6C09A776-A270-451-AEB4-877AA31F5F0F',
  },
  {
    name: 'Nexus 5',
    identityAccountId: 'D3703-9338-4CF2-AF32-AF0E3F30C1C9',
    resourceType: 'legal_entity',
    parentId: '6C09A776-A27251-AEB4-877AA31F5F0F',
  },
  {
    name: 'Nexus 6',
    identityAccountId: 'D37B1-9338-4CF-AF32-AF0E3F30C1C9',
    resourceType: 'legal_entity',
    parentId: '6C09A776-A270-4251--877AA31F5F0F',
  },
  {
    name: 'Nexus 7',
    identityAccountId: 'D37B1-9338-4CF-0E3F30C1C9',
    resourceType: 'legal_entity',
    parentId: '6C09A776-A270-4251--877AA31F5F0F',
  },
  {
    name: 'Very long legal entity name',
    identityAccountId: 'D37B1-sdfhsdhf9338-4CF-AF32-AF0E3F30C1C9',
    resourceType: 'legal_entity',
    parentId: '6C09A776-A270-4251--877AA31F5F0F',
  },
  {
    name: 'Test Org 3',
    identityAccountId: '6C09A776-A270-4251-AEB4-877AA31F5F0F',
    resourceType: 'organization',
  },
  {
    name: 'Test Org',
    identityAccountId: 'C8D13E39-CEF0-4035-98E8-A59527650777',
    resourceType: 'organization',
  },
  {
    name: 'Felipe Enterprise',
    identityAccountId: 'f138982f-24b4-40c8-91a2-9355c03cd170',
    resourceType: 'organization',
  },
];

export const MOCK_HELP_MENU: HelpMenu = {
  subtitle: 'Visit the Help Center or contact us.',
  title: 'Need Help?',
  pictogram: 'helpCenterNavigation',
  actions: [
    {
      callbackUrl: 'https://helpcenter-dev.cbhq.net',
      key: 'help',
      icon: 'support',
      label: 'Help',
    },
    {
      callbackUrl: 'https://docs.cdp.coinbase.com/',
      key: 'developer_docs',
      icon: 'peopleGroup',
      label: 'Developer Docs',
    },
    {
      callbackUrl: 'https://coinbase-dev.cbhq.net/concierge',
      key: 'concierge',
      imageUrl:
        'https://res.cloudinary.com/coinbase/image/upload/f_png,c_fill,h_128,w_128/b8hrowydzuqyh3epwz4g.png',
      label: 'Your Concierge',
      description: 'Schedule a call with Woody',
    },
  ],
};

export function mockGetProfileMenu() {
  return {
    name: 'Satoshi Nakamoto',
    email: 'satoshi@coinbase.com',
    avatarUrl:
      'https://res.cloudinary.com/coinbase/image/upload/f_png,c_fill,h_128,w_128/b8hrowydzuqyh3epwz4g.png',
    profileManagementUrl: 'https://accounts-dev.cbhq.net/profile',
    actions: [
      {
        callbackUrl: 'https://accounts-dev.cbhq.net/',
        key: 'settings',
        icon: 'settings',
        label: 'My Preferences',
      },
      {
        callbackUrl: 'https://accounts-dev.cbhq.net/signout',
        key: 'sign_out',
        icon: 'backArrow',
        label: 'Sign out',
      },
    ],
    helpMenu: MOCK_HELP_MENU,
    resources: MOCK_RESOURCES,
  };
}

export const MOCK_PROFILES: ProfilesType = [
  {
    userUuid: 'mock-uuid-0',
    name: 'Satoshi Nakamoto',
    avatarUrl:
      'https://res.cloudinary.com/coinbase/image/upload/f_png,c_fill,h_128,w_128/b8hrowydzuqyh3epwz4g.png',
    email: 'satoshi@coinbase.com',
    expiresAt: '3024-10-13T19:00:00.000Z',
    profileId: 'mock-profile-id-0',
  },
  {
    userUuid: 'mock-uuid-1',
    name: 'Cristiano Ronaldo',
    email: 'cristiano_ronaldo@coinbase.com',
    expiresAt: '2024-03-10T18:17:05Z',
    profileId: 'mock-profile-id-1',
  },
  {
    userUuid: 'mock-uuid-2',
    name: 'Thierry Henry',
    email: 'thierry_henry@coinbase.com',
    expiresAt: '2024-10-13T19:00:00.000Z',
    profileId: 'mock-profile-id-2',
  },
  {
    userUuid: 'mock-uuid-3',
    name: 'Michael Jordan',
    email: 'michael_jordan@coinbase.com',
    expiresAt: '2025-10-13T19:00:00.000Z',
    profileId: 'mock-profile-id-3',
  },
];

export const MOCK_ACTIONS: MenuActionItem[] = [
  {
    callbackUrl: 'https://accounts-dev.cbhq.net/profile',
    key: 'profile_management',
    icon: 'account',
    label: 'Manage account',
  },
  {
    callbackUrl: 'https://accounts-dev.cbhq.net/',
    key: 'settings',
    icon: 'settings',
    label: 'My Preferences',
  },
  {
    callbackUrl: 'https://accounts-dev.cbhq.net/signout',
    key: 'sign_out',
    icon: 'settings',
    label: 'Sign out of all accounts',
  },
];

export const MOCK_LABELS: ProfileMenuContextType['labels'] = [
  {
    key: CoinbaseProfileMenuLabelKey.OTHER_ACCOUNTS,
    value: 'Other Accounts',
  },
];

export function mockGetProfileMenuV2() {
  return {
    profiles: MOCK_PROFILES,
    actions: MOCK_ACTIONS,
    helpMenu: MOCK_HELP_MENU,
    labels: MOCK_LABELS,
    resources: MOCK_RESOURCES,
  };
}
